<script lang="ts" setup>
defineProps<{
  theme: 'blue' | 'white' | 'green' | 'red' | 'forced-dark-blue' | 'teal' | 'light'
  label: string
}>();
</script>

<template>
  <div class="current" :class="theme">
    <slot/>
    {{ label }}
  </div>
</template>
<style lang="scss" scoped>
.current {
  border-radius: var(--button-border-radius);
  @include font-caption-sm;
  color: var(--Neutral-UI-neutral-ui-100);
  height: fit-content;
  width: fit-content;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: var(--Spacing-spacing-2);
  &.white {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-100);
    background-color: var(--Light-Scheme-Neutral-UI-neutral-ui-10)
  }
  &.blue {
    color: var(--Neutral-UI-neutral-ui-100);
    background-color: var(--Functional-wl-current-surface);
  }
  &.green {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-0);
    background-color: var(--Functional-wl-completed-surface);
  }
  &.red {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-0);
    background-color: var(--Primary-primary-color-3);
  }
  &.forced-dark-blue {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-0);
    background-color: var(--Dark-Scheme-Functional-wl-current-surface);
  }
  &.teal {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-0);
    background-color: var(--Data-Visualization-13);
  }
  &.light {
    color: var(--Light-Scheme-Neutral-UI-neutral-ui-90);
    background-color: var(--Light-Scheme-Neutral-UI-neutral-ui-20);
  }
}
</style>
